/* eslint-disable custom/no-hardcoded-colors */
import * as React from 'react';
import { Button, Icon, styled, theme } from 'design-system';
import Image from 'next/image';

const Overlay = styled('div', {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
});

const ErrorContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '32px',
  textAlign: 'center',
  minWidth: '500px',
  backgroundColor: theme.colors.white,
  borderRadius: '8px',
  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
  position: 'relative',
});

const CloseButton = styled('button', {
  position: 'absolute',
  top: '16px',
  right: '16px',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.colors.gray11,
  transition: 'color 0.2s',
  '&:hover': {
    color: theme.colors.gray12,
  },
});

const ErrorIconWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '60px',
  height: '60px',
  borderRadius: '50%',
  marginBottom: '14px',
});

const ErrorTitle = styled('h2', {
  fontSize: '14px',
  fontWeight: '600',
  color: '#B52749',
  lineHeight: '20px',
});

const ErrorMessage = styled('p', {
  fontSize: '14px',
  color: theme.colors.blue12,
  fontWeight: '500',
  marginBottom: '14px',
  lineHeight: '1.5',
});

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onRetry: () => void;
  errorMessage?: string;
  errorTitle?: string;
};

export const UploadErrorModal = ({
  isOpen,
  onClose,
  onRetry,
  errorMessage = 'An error occurred while uploading your file. Please try again.',
  errorTitle = 'Upload Failed',
}: Props) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Overlay
      onClick={(e) => {
        // Close when clicking overlay background
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <ErrorContainer>
        <CloseButton onClick={onClose} aria-label="Close">
          <Icon name="x" variant="solid" width={24} height={24} />
        </CloseButton>

        <ErrorIconWrapper>
          <Image src="/error-new.svg" alt="Error Icon" width={60} height={60} />
        </ErrorIconWrapper>

        <div
          style={{
            padding: '15px',
            background: '#FFE8E8',
            borderRadius: '40px',
            marginBottom: '14px',
          }}
        >
          <ErrorTitle>{errorTitle}</ErrorTitle>
        </div>
        <ErrorMessage>{errorMessage}</ErrorMessage>

        <Button
          color="primary"
          size="medium"
          onClick={onRetry}
          aria-label="Try again"
          css={{
            width: '300px',
          }}
        >
          Try Again
        </Button>
      </ErrorContainer>
    </Overlay>
  );
};
